/** Logical key; physical template and column UUIDs are allocated per workspace. */
export enum OttopilotOtpWorkspaceCapabilityUdoTemplateKey {
    otp = "e90241bf-fc61-4d2d-bbb4-b6f42d107344",
}
